import PlatformUserAccess from "./PlatformUserAccess";

export default PlatformUserAccess;
